import { useExtensionConfig } from '~/hooks/useExtensionConfig';

import { DoctorCard } from './DoctorCard';

export const BrowserInfo = () => {
  const { browserName, browserVersion } = useExtensionConfig();
  return (
    <DoctorCard
      title="Browser Info"
      rows={[
        {
          label: 'Browser name',
          value: browserName,
        },
        {
          label: 'Browser Version',
          value: browserVersion,
        },
      ]}
    />
  );
};
